





























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {PageCollection, Resource} from 'simpli-web-sdk'

@Component
export default class ItTable extends Vue {
  @Prop({required: true}) collection!: PageCollection<Resource>
  @Prop({type: Array}) toRender?: string[]
  @Prop({type: String}) innerClass!: string
  @Prop({type: Number, default: 0}) renderIndex!: number
  @Prop({type: Boolean, default: true}) spinnerInit!: boolean
  @Prop({type: String, default: 'query'}) spinner!: string
  @Prop({type: Boolean, default: true}) centralized!: boolean
  @Prop({type: Boolean, default: false}) disableOrderBy!: boolean
  @Prop({type: Boolean, default: false}) hidePagination!: boolean
  @Prop({type: String}) dynamicEmptyList?: string

  get resourceName() {
    return this.collection.resource.$name
  }

  get headersToRender() {
    return this.toRender || this.collection.resource.fieldsToRender
  }

  get spinnerColor() {
    if (this.innerClass) {
      return this.innerClass.includes('contrast') ? '#ffbb16' : 'white'
    }
    return 'white'
  }

  get textContrast() {
    if (this.innerClass) {
      return this.innerClass.includes('contrast') ? '' : 'contrast'
    }
    return 'contrast'
  }

  get centralizedClassOrNot() {
    return this.centralized ? 'items-center text-center' : ''
  }

  fieldsToRender(resource: Resource) {
    return this.toRender || resource.fieldsToRender
  }

  translate(field: string) {
    return this.$t(`classes.${this.resourceName}.columns.${field}`)
  }
}
